export const PROFILE_NAME = 'profile';
export const TEAM_NAME = 'team';
export const PREFERENCES_NAME = 'preferences';
export const BILLING_NAME = 'billing';
export const BRAND_NAME = 'brand';
export const TRADE_INFO_NAME = 'trade-info';
